import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from 'react-loader-spinner';
import { useNavigate, useParams, Link } from "react-router-dom";
import Select from "react-select";
function CustomerEdit() {
    const [duration, setDuration] = useState({});
    const [loading, setLoading] = useState(true);
    const [newStb, setNewStb] = useState(true);
    const [box, setBox] = useState(true);
    const [boxSave, setBoxSave] = useState("");
    const [staff, setStaff] = useState({});
    const [staffs, setStaffs] = useState({});
    const [Stb, setStb] = useState(true);
    const [oldStb, setOldStb] = useState(null);
    const [oldData, setOldData] = useState([]);
    const [stbError, setStbError] = useState(null);
    const [error, setError] = useState(null);
    const [EditCustomer, setEditCustomer] = useState({});
    const [streetName, setStreetName] = useState([]);
    const [group, setGroup] = useState("");
    const [replacement, setReplacement] = useState("");
    const [incentive, setIncentive] = useState("");
    const [installed, setInstalled] = useState("");

    const [reverse, setReverse] = useState(false);
    const [pack, setPackage] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate();
    const [paidEdit, setPaidEdit] = useState("");
    const { id } = useParams();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const user = getCookie('user');
    const [paidAmt, setpaidAmt] = useState(0);
       const [ExtrapaidAmt, setExtrapaidAmt] = useState(0);
         const [payAmt, setPayamt] = useState(0);
       
    const [balance, setBalance] = useState(0);
    const [secret, setSecret] = useState('');
    const [paidDate, setPaidDate] = useState('');
    const [paidTime, setPaidTime] = useState('');
    const [ColBoy, setColBoy] = useState('');
    const [Code, setCode] = useState('');
    const [status, setStatus] = useState('');
    const [remark, setRemark] = useState('');
const [isSubmitting, setIsSubmitting] = useState(false);

    if (!user) { navigate('/login'); }

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        }
        return null;
    }

    const handlePaidAmtChange = (event) => {
        setPaidEdit(event.target.value);
    };
   const handleInputChange = (e) => {
  const { name, value } = e.target;

  if (name === "serial_num") {
    setStbError(null);
    setNewStb(value);
  } 
  else if (name === "street") {
    const selectedStreet = streetName.find(
      (street) => street.street_name === value
    );
    if (selectedStreet) {
      setEditCustomer((prev) => ({
        ...prev,
        [name]: value,
        net_name: selectedStreet.network_name,
        area_code: selectedStreet.area_code,
      }));
    } else {
      setEditCustomer((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  } 
  else if (name === "pay_amt") {
    
    const newBalance = Number(value) || 0;
    setEditCustomer((prev) => ({
      ...prev,
      [name]: value,
      balance_amt: newBalance,
    }));
    setBalance(newBalance); 
  } 
  else if (name === "discount") {
    // ✅ Always calculate new balance from original base (`balance`)
    const discount = Number(value) || 0;
    const base = Number(balance) || 0; // your existing balance state
    const newBalance = Math.max(base - discount, 0); // prevent negative
    setEditCustomer((prev) => ({
      ...prev,
      [name]: value,
      balance_amt: newBalance,
    }));
  } 
  else {
    setEditCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/EditCustomerGetInfo', { user, id });
            if (response.status === 200) {
                console.log(response.data);
                setStreetName(response.data.street);
                setGroup(response.data.group);
                setEditCustomer(response.data.EditCustomer[0]);
                setPackage(response.data.package);
                setBox(response.data.box);
                setStaff((response.data.staff).map((item, a) => ({ value: item.area_code, label: item.name, })));
                setStaffs(response.data.staff);
                setStb(response.data.newStb);
                setOldStb(response.data.EditCustomer[0].serial_num);
                setpaidAmt(Number(response.data.EditCustomer[0].paid_amt));
                 setExtrapaidAmt(Number(response.data.EditCustomer[0].extra_balance_amt));
                setBalance(Number(response.data.EditCustomer[0].balance_amt));
                setSecret(response.data.EditCustomer[0].secret_id);
                setPayamt(response.data.EditCustomer[0].pay_amt);
              
                setPaidDate(response.data.EditCustomer[0].paid_date);
                setPaidTime(response.data.EditCustomer[0].paid_time);
                setColBoy(response.data.EditCustomer[0].col_boy);
                setCode(response.data.EditCustomer[0].carea_code);
                setStatus(response.data.EditCustomer[0].status);
                setOldData(JSON.parse(JSON.stringify(response.data.EditCustomer[0])));
                console.log("response", response.data.EditCustomer[0]);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
            console.log(err);
        } finally { setLoading(false); }
    };
    async function handleReverse(e) {
        e.preventDefault();
        setReverse(!reverse)
        if (!reverse) {
            console.log("old1", oldData);
            console.log("reverse", EditCustomer.paid_amt, EditCustomer.balance_amt);
            EditCustomer.paid_amt = 0;
            EditCustomer.balance_amt = paidAmt
             
            EditCustomer.extra_balance_amt=""
            EditCustomer.secret_id = ""
           
            EditCustomer.paid_date = ""
            EditCustomer.paid_time = ""
            EditCustomer.pend_amt = ""
            EditCustomer.col_boy = ""
            EditCustomer.carea_code = ""
            EditCustomer.status = 'unpaid'
             console.log("old2", oldData);
            setReverse(!reverse);
            return
        } else {
            EditCustomer.paid_amt = paidAmt;
            EditCustomer.balance_amt = balance;
             EditCustomer.extra_balance_amt=ExtrapaidAmt;
            console.log("undo", EditCustomer.paid_amt, EditCustomer.balance_amt);
            EditCustomer.secret_id = secret
            EditCustomer.paid_date = paidDate
            EditCustomer.paid_time = paidTime
            EditCustomer.col_boy = ColBoy
            EditCustomer.carea_code = Code
            EditCustomer.status = 'paid'
           console.log("old un reverse", oldData);
            setReverse(!reverse);
            return
        }
       

    }

  async function handleStbReplace(e) {
  e.preventDefault();

  if (isSubmitting) return; // 🚫 double click block

  setIsSubmitting(true); // 🔒 lock button


  try {
    const response = await axios.post(
      "https://node.cabletvpay.in/handleStbReplace",
      { user, remark, selectedOptions, incentive, installed, replacement, boxSave, id, oldStb, newStb }
    );

    if (response.status === 200) {
      toast.success("✅ Changes Saved Successfully");

      EditCustomer.serial_num = newStb;

      setTimeout(() => {
       
        navigate("/allCustomer/all", {
          state: { customerId: response.data.id }
        });
        window.location.reload();

      }, 1200);
    }

  } catch (error) {
    toast.error(error.message || "Failed to update");
    console.error(error);
  } finally {
    setIsSubmitting(false); // 🔓 unlock (safety)
  }
}
    function durationChange(e) {
        if (Array.isArray(e.value)) {
            setDuration((prev) => ({
                ...prev,
                selectedOptions: e.value,
            }));
        } else {
            const { name, value } = e.target;
            setDuration((prev) => ({ ...prev, [name]: value, }));
        }
        console.log(duration);
    }
    async function editSubmit(e) {
        e.preventDefault();
        try {
            const response = await axios.post('https://node.cabletvpay.in/EditFormSubmit', { user, EditCustomer, reverse, oldData });
            if (response.status === 200) {
                toast.success("Changes Saved Successfully");
                  navigate("/allCustomer/all", {
                state: { customerId: response.data.customerId }
                });

     
            } 
        
        } catch (err) { toast.error("Changes not saved"); }
    }
    async function verifyStb(e) {
        e.preventDefault();
        if (!newStb.trim() || newStb.includes(" ")) {
            setNewStb(oldStb);
            toast.warning("Entered STB is empty or contains spaces. Please re-enter.");
            return;
        }
        try {
            
    
            const response = await axios.post('https://node.cabletvpay.in/verifyStb', { newStb, user, stbError, oldStb });
    
            if (response.status === 200) {
                console.log("STB Verification Response:", response.data);
    
                // ✅ Update STB Error State
                setStbError(response.data.stb);
    
                // ✅ Store Available STB Names (if provided)
                if (response.data.STBname) {
                    setBox(response.data.STBname);
                }
            }
        } catch (err) {
            console.error("STB Verification Failed:", err);
            setError(err.response?.data?.message || "Error fetching data");
        } 
    }
    
    
    useEffect(() => { fetchUserData(); }, []);

    if (loading) return (<div className="content-wrapper"> <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}> <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" /></div></div>)
    if (error) return <div className="content-wrapper"> <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}><img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} /> </div></div>;



    return (
        <div className="content-wrapper px-3" >
            <div className="content-header pt-1">
                <div style={{ position: "absolute", top: "30px" }}><ToastContainer /></div>
                <div className="my-0 py-0 mt-3 h-50 d-flex justify-content-lg-between">
                    <h3 className="text-orange text-bold"><span className='text-navy'>CUSTOMER EDIT : </span> {EditCustomer.name}</h3>
 
<button
  type="button"
  className="btn border-0 bg-gradient-purple text-light mt-1 h-25"
  onClick={() =>
    navigate("/allCustomer/all", {
      state: { customerId: id },
      replace: true
    })
  }
>
  Back
</button>



                </div>
                <hr className='mt-2' />
                <form >
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="name" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Customer Name</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="name" name="name" type="text" placeholder="Name.." value={EditCustomer.name} onChange={handleInputChange} autoComplete='off' />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="caf_num" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>CAF Number</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="caf_num" name="caf_num" type="text" placeholder="caf number.." value={EditCustomer.caf_num} onChange={handleInputChange} autoComplete='off' />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="account_num" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Account Number</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="account_num" name="account_num" type="text" placeholder="Account number.." value={EditCustomer.account_num} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="serial_num" className=" text-navy valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>STB Number</label>
                                <div className="input-group elevation-3 rounded border-dark">
                                    <input className="form-control text-black text-bold border-secondary" id="serial_num" name="serial_num" type="text" placeholder="Account number.." value={EditCustomer.serial_num} onChange={handleInputChange} disabled style={{ backgroundColor: "lightgrey" }} />


                                    <button type="button" className="btn bg-gradient-success text-light border-secondary" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: 'none' }} data-toggle="modal" data-target="#exampleModal">Change</button>

                                    <div className="modal" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div className="modal-dialog modal-lg modal-dialog-centered ">
                                            <div className="modal-content">
                                                <div className="modal-header bg-gradient-navy">
                                                    <h4 className="modal-title pt-0 mt-0" id="exampleModalLabel">Change STB Number</h4>
                                                    <button type="button" className="close fa-w-1 " data-dismiss="modal" aria-label="Close">
                                                        <span className="text-white" aria-hidden="true">X</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <label htmlFor="OldSerial_num" className=" text-navy valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Old STB Number : </label>
                                                            <input className="form-control text-white bg-gradient-secondary text-bold border-secondary" id="serial_num" name="serial_num" type="text" placeholder="Account number.." value={oldStb} disabled />
                                                        </div>
                                                        <div className="col-6">
                                                            <label htmlFor="serial_num" className=" text-navy valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>New STB Number : </label>
                                                            <input className="form-control text-black text-bold border-secondary bg-white" id="serial_num" name="serial_num" type="text" placeholder="Account number.." list="stb" onChange={(e) => { setNewStb(e.target.value); setStbError(" ") }} autoComplete='off' />
                                                            <datalist id="stb">
                                                                {
                                                                    Stb.map((item, index) => (
                                                                        <option key={index} value={item.stb}>{item.stb}</option>
                                                                    ))
                                                                }
                                                            </datalist>
                                                        </div>
                                                    </div>
                                                    {stbError === 0 ? (
                                                        <div className="row mt-2">
                                                            <div className="col-6">
                                                                <label htmlFor="Replacement_Amount" className="valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Replacement Amount : </label>
                                                                <input className="form-control text-bold border-secondary bg-white" id="serial_num" name="serial_num" type="text" placeholder="Replacement Amount ₹ .." onChange={(e)=> {setReplacement(e.target.value)}} />
                                                            </div>
                                                            <div className="col-6">
                                                                <label htmlFor="BoxModal" className="valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Box Model / Type : </label>
                                                                <input className="form-control text-bold border-secondary bg-white" id="serial_num" name="serial_num" type="search" list="box" placeholder="Box Model / Type : .." autoComplete='off' value={boxSave} onChange={(e)=> {e.preventDefault(); setBoxSave(e.target.value)}} />
                                                                <datalist id='box'>
                                                                    {
                                                                        box.map((item, index) => (
                                                                            <option key={index} value={item.stbname}>{item.stbname}</option>
                                                                        ))
                                                                    }
                                                                </datalist>
                                                            </div>
                                                            <div className="col-6">
                                                                <label htmlFor="Replacement_Amount" className="valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Incentive Amount : </label>
                                                                <input className="form-control text-bold border-secondary bg-white" id="serial_num" name="serial_num" type="text" placeholder="Incentive Amount ₹..." onChange={(e)=> {setIncentive(e.target.value)}}/>
                                                            </div>
                                                            <div className="col-6">
                                                                <label htmlFor="installation_amount" className="valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Installed By : </label>
                                                                <Select options={staff} isMulti value={selectedOptions} placeholder="Select an Option" className="text-navy border-dark" classNamePrefix="select" onChange={(selected) => {
                                                                    setSelectedOptions(selected);
                                                                    durationChange({ name: "selectedOptions", value: selected }); // Pass as an object to match other inputs
                                                                }}
                                                                    styles={{
                                                                        control: (baseStyles) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: "white",
                                                                        }),
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <label htmlFor="Remarks" className="valuesDec d-block mb-2" style={{ borderRadius: "50px" }}>Remarks : </label>
                                                                <input className="form-control text-bold border-secondary bg-white" id="Remarks" name="Remarks" type="text" placeholder="Remarks ..." onChange={(e)=>{e.preventDefault(); setRemark(e.target.value);}}/>
                                                            </div>
                                                           <div className="col-6">
                                                                                <label
                                                                                    htmlFor="amountCollected"
                                                                                    className="valuesDec d-block mb-2"
                                                                                    style={{ borderRadius: "50px" }}
                                                                                >
                                                                                    Amount Collected By :
                                                                                </label>

                                                                                <select
                                                                                    className="form-control text-bold border-secondary bg-white"
                                                                                    name="amountCollected"
                                                                                    id="amountCollected"
                                                                                    value={installed || ""} // ✅ ensure controlled component
                                                                                    onChange={(e) => {
                                                                                    e.preventDefault();
                                                                                    setInstalled(e.target.value);
                                                                                    }}
                                                                                >
                                                                                    {/* ✅ Default Option */}
                                                                                    <option value="" disabled>
                                                                                    Select an option
                                                                                    </option>

                                                                                    {staffs.length > 0 ? (
                                                                                    staffs.map((item, index) => (
                                                                                        <option key={index} value={`${item.name}-${item.area_code}`}>
                                                                                        {`${item.name} - (${item.area_code})`}
                                                                                        </option>
                                                                                    ))
                                                                                    ) : (
                                                                                    <option value="">No Staff</option>
                                                                                    )}
                                                                                </select>
                                                                                </div>


                                                        </div>
                                                    ) : ("")
                                                    }

                                                </div>
                                                <div className="modal-footer">
                                                    <div className="d-flex justify-content-center">
                                                        {stbError === 1 ? (<span className='text-danger'>Already in use</span>) : stbError === 0 ? (<span className='text-success'>Verified to use</span>) : null}
                                                    </div>
                                                    <button type="button" className="btn btn-success" onClick={verifyStb}>Verify STB</button>
                                                    <span>{stbError === 0 ? ( <button
                                                                className="btn btn-info"
                                                                onClick={handleStbReplace}
                                                                disabled={isSubmitting}
                                                                >
                                                                {isSubmitting ? "Submitting..." : "Save Data"}
                                                                </button>
                                                                ): ("")}</span>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Code :</label>
                                <input className="form-control text-black text-bold border-secondary elevation-3" id="group" name="groupname" type="text" placeholder="Account number.." value={EditCustomer.acc_num} disabled style={{ backgroundColor: "lightgrey" }} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="flat_name" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Flat Name</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="flat_name" name="flat_name" type="text" placeholder="Flat Name" value={EditCustomer.flat_name} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="customer_group" className="text-center valuesDec text-navy">Customer Group</label>
                                <select className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="customer_group" name="customer_group" value={EditCustomer.customer_group} onChange={handleInputChange}>
                                    <option className="bg-light" value="">None</option>
                                    {group.length > 0 ? (
                                        group.map((row, index) => (
                                            <option key={index} className="bg-light" value={row.group_name}>{row.group_name}</option>
                                        ))) : (<option className="bg-light" value="">No groups available</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="net_name" className="text-center valuesDec text-navy">Network Name</label>
                                <input className="form-control text-black text-bold border-secondary elevation-3" id="net_name" name="net_name" value={EditCustomer.net_name} onChange={handleInputChange} disabled style={{ backgroundColor: "lightgrey" }} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="doorno" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Door No</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="doorno" name="doorno" type="text" placeholder="Door No" value={EditCustomer.doorno} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="mobile" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Mobile Number</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="mobile" name="mobile" type="text" placeholder="mobile" value={EditCustomer.mobile} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="alternative_mobile" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Alternative Mobile Number</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="alternative_mobile" name="alternative_mobile" type="text" placeholder="Alternative mobile" value={EditCustomer.alternative_mobile} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="street" className="text-center valuesDec text-navy">Street Name</label>
                                <select className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="street" name="street" value={EditCustomer.street} onChange={handleInputChange}>
                                    {streetName.length > 0 ? (
                                        streetName.map((row, index) => (
                                            <option key={index} className="bg-light" value={row.street_name}>{row.street_name}</option>
                                        ))) : (<option className="bg-light" value="">No groups available</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="area_code" className="text-center valuesDec text-navy">Staff Code</label>
                                <input className="form-control text-black text-bold border-secondary elevation-3" id="area_code" name="area_code" value={EditCustomer.area_code} disabled style={{ backgroundColor: "lightgrey" }} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="discount" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Discount Amount</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="discount" name="discount" type="text" placeholder="discount amout" value={EditCustomer.discount} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="status" className="text-center valuesDec text-navy">Status</label>
                                <select className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="status" name="status" value={EditCustomer.status} onChange={handleInputChange}>
                                    <option className='bg-light' value="paid">Paid</option>
                                    <option className='bg-light' value="unpaid">Unpaid</option>
                                    <option className='bg-light' value="extra paid">Extra Paid</option>
                                    <option className='bg-light' value="pending">Pending</option>
                                    <option className='bg-light' value="free">Free</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="paid_amt" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Paid Amount</label>
                                <input className="form-control bg-warning text-black text-bold border-secondary elevation-3 " id="paid_amt" name="paid_amt" type="text" placeholder="paid amount" value={EditCustomer.paid_amt} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="pay_amt" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Package Amount</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="pay_amt" name="pay_amt" type="text" placeholder="Package" value={EditCustomer.pay_amt} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Edit Paid Amount</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="paidedit" name="paidedit" type="text" placeholder="edit paid amount" value={paidEdit} onChange={handlePaidAmtChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="balance_amt" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Current Month Balance Amount</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="balance_amt" name="balance_amt" type="text" placeholder="Balance" value={EditCustomer.balance_amt} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="package" className="text-center valuesDec text-navy">Package</label>
                                 <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="package" name="package" type="text" placeholder="package" value={EditCustomer.package} onChange={handleInputChange} />
                                {/* <select className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="package" name="package" list="package" value={EditCustomer.package || ""} onChange={handleInputChange} >
                                    {pack.length > 0 ? (
                                        pack.map((row, index) => (
                                            <option className="bg-light" value={row.package}>
                                                {row.package}
                                            </option>
                                        ))
                                    ) : (
                                        <option className="bg-light" value="">
                                            No Packages Available
                                        </option>
                                    )}
                                </select> */}
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Location</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="location" name="location" type="text" placeholder="location" value={EditCustomer.location} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2 date">
                            <div className="form-group">
                                <label htmlFor="paid_date" className="text-center valuesDec text-navy ">Paid Date</label>
                                <input type="date" className="form-control  bg-warning text-black text-bold border-secondary elevation-3 " name="paid_date" id="paid_date" value={EditCustomer.paid_date} onChange={handleInputChange} style={{ backgroundColor: "lightgrey" }} disabled/>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="secret_id" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>User ID</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="secret_id" name="secret_id" type="text" placeholder="user id" value={EditCustomer.secret_id} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Collection Staff</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="Balance" name="collectionstaff" type="collectionstaff" placeholder="collectionstaff" value={EditCustomer.col_boy + " - " + EditCustomer.carea_code} disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Previous Month Pending Amount :</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="pend_amt" name="pend_amt" type="text" placeholder="premonthpending" value={EditCustomer.pend_amt} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="carea_code" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Collection Staff Code</label>
                                <input className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="carea_code" name="carea_code" type="text" placeholder="collectionstaffcode" value={EditCustomer.carea_code} disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="extra_balance_amt" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Advance Amount</label>
                                <input className="form-control  bg-warning text-black text-bold border-secondary elevation-3" id="extra_balance_amt" name="extra_balance_amt" type="text" placeholder="extra balance amount" value={EditCustomer.extra_balance_amt} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <label htmlFor="con_status" className="text-center valuesDec text-navy">Connection Status</label>
                                <select className="form-control bg-gradient-light text-black text-bold border-secondary elevation-3" id="con_status" name="con_status" value={EditCustomer.con_status} onChange={handleInputChange} disabled>
                                    <option className='bg-light' value="active">active</option>
                                    <option className='bg-light' value="deactive">deactive</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-12 mb-4 pt-2 pt-lg-4 mt-lg-2">
                            <div className="d-flex justify-content-center">
                                <input type="checkbox" className="mt-1" name="credit" checked={isChecked} onChange={() => setIsChecked(prev => !prev)} />
                                <label className='pt-1' style={{ marginLeft: "10px" }}> Credit Customer </label>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                            <input type="submit" className="btn filterBtn border-0 bg-success text-light pb-3 pb-lg-1 w-100" value="Submit" onClick={editSubmit} style={{ height: "50px" }} />
                        </div>
                        <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                            <Link to={`/allCustomer/all`} className="btn bg-danger filterBtn w-100 pt-3" style={{ height: "50px" }}>Back</Link>
                        </div>
                        <div className={`col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2`}>
                            <button  type="button" className={`btn filterBtn bg-info w-100 ${status === 'unpaid' ? `d-none` : ` `}`} onClick={handleReverse} style={{ height: "50px" }}>{reverse ? 'Undo' : 'Reverse Payment'}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CustomerEdit;